import React from 'react';
import './PerformanceChart.css';

const PerformanceChart = ({ data, title, type = 'line' }) => {
  if (!data || data.length === 0) {
    return (
      <div className="performance-chart">
        <h4>{title}</h4>
        <div className="chart-placeholder">
          <p>No data available</p>
        </div>
      </div>
    );
  }

  const renderChart = () => {
    switch (type) {
      case 'line':
        return renderLineChart();
      case 'bar':
        return renderBarChart();
      case 'metric':
        return renderMetricCard();
      default:
        return renderLineChart();
    }
  };

  const renderLineChart = () => {
    const maxValue = Math.max(...data.map(d => d.value));
    const minValue = Math.min(...data.map(d => d.value));
    const range = maxValue - minValue;

    return (
      <div className="chart-container">
        <svg width="100%" height="120" viewBox="0 0 300 120">
          <defs>
            <linearGradient id="lineGradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#a06eff" stopOpacity="0.8"/>
              <stop offset="100%" stopColor="#a06eff" stopOpacity="0.1"/>
            </linearGradient>
          </defs>
          
          {/* Grid lines */}
          {[0, 25, 50, 75, 100].map(y => (
            <line
              key={y}
              x1="0"
              y1={y}
              x2="300"
              y2={y}
              stroke="#eee"
              strokeWidth="1"
            />
          ))}
          
          {/* Data line */}
          <polyline
            fill="none"
            stroke="#a06eff"
            strokeWidth="2"
            points={data.map((d, i) => {
              const x = (i / (data.length - 1)) * 280 + 10;
              const y = 110 - ((d.value - minValue) / range) * 100;
              return `${x},${y}`;
            }).join(' ')}
          />
          
          {/* Area fill */}
          <polygon
            fill="url(#lineGradient)"
            points={`10,110 ${data.map((d, i) => {
              const x = (i / (data.length - 1)) * 280 + 10;
              const y = 110 - ((d.value - minValue) / range) * 100;
              return `${x},${y}`;
            }).join(' ')} 290,110`}
          />
          
          {/* Data points */}
          {data.map((d, i) => {
            const x = (i / (data.length - 1)) * 280 + 10;
            const y = 110 - ((d.value - minValue) / range) * 100;
            return (
              <circle
                key={i}
                cx={x}
                cy={y}
                r="3"
                fill="#a06eff"
                stroke="#fff"
                strokeWidth="2"
              />
            );
          })}
        </svg>
        
        {/* X-axis labels */}
        <div className="chart-labels">
          {data.map((d, i) => (
            <span key={i} className="chart-label">
              {d.label}
            </span>
          ))}
        </div>
      </div>
    );
  };

  const renderBarChart = () => {
    const maxValue = Math.max(...data.map(d => d.value));
    
    return (
      <div className="chart-container">
        <div className="bar-chart">
          {data.map((d, i) => (
            <div key={i} className="bar-group">
              <div 
                className="bar" 
                style={{ 
                  height: `${(d.value / maxValue) * 100}%`,
                  backgroundColor: `hsl(${240 + (i * 30) % 360}, 70%, 60%)`
                }}
              />
              <span className="bar-label">{d.label}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderMetricCard = () => {
    const latest = data[data.length - 1];
    const previous = data[data.length - 2];
    const change = previous ? ((latest.value - previous.value) / previous.value) * 100 : 0;
    
    return (
      <div className="metric-card">
        <div className="metric-value">{latest.value.toLocaleString()}</div>
        <div className={`metric-change ${change >= 0 ? 'positive' : 'negative'}`}>
          {change >= 0 ? '↗' : '↘'} {Math.abs(change).toFixed(1)}%
        </div>
        <div className="metric-label">{latest.label}</div>
      </div>
    );
  };

  return (
    <div className="performance-chart">
      <h4>{title}</h4>
      {renderChart()}
    </div>
  );
};

export default PerformanceChart;


